import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'ToggleSubmit';

class ToggleSubmit extends BaseComponent {
	constructor(element) {
		super(element);
		this.button = SelectorEngine.findOne( 'input', element);
		this.form = element.closest('form');
		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		EventHandler.on(this.button, 'change', (e) => {
			this?.form?.submit();
		});
	}
}

export default ToggleSubmit;
